import { useState } from "react";
import { apiFetch } from "api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import "assets/theme/admin_form.css";

const AddHelpCategory = () => {
  const navigate = useNavigate();
  const [categoryName, setCategoryName] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const newErrors = {};
    if (!categoryName.trim()) {
      newErrors.categoryName = "Category name is required / श्रेणीचे नाव आवश्यक आहे";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLoading(true);

    try {
      await apiFetch("super_admin/add_help_category", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          category_name: categoryName.trim(),
        }),
      });

      alert("Help category added successfully / मदत श्रेणी यशस्वीरित्या जोडली गेली");
      navigate("/help_category_list");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>
        {/* Header Card */}
        <div className="admin-form-header-card">
          <div className="d-flex align-items-center gap-3">
            <button type="button" onClick={() => navigate(-1)} className="btn-admin-back">
              <FaArrowLeft />
              <span>मागे जा (Back)</span>
            </button>
            <div>
              <h4 className="fw-bold mb-1 text-white">
                🤝 मदत श्रेणी जोडा (Add Help Category)
              </h4>
              <small className="text-white-50">
                Create categories like Medical, Financial Assistance, etc.
              </small>
            </div>
          </div>

          <Link to="/help_category_list" className="btn btn-light btn-sm fw-semibold rounded-pill px-3">
            Category List
          </Link>
        </div>

        <div className="card shadow-lg rounded-4 border-0">
          <div className="card-body p-4">
            <form onSubmit={handleSubmit} noValidate>
              <div className="row g-4">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">
                    Category Name / श्रेणीचे नाव <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.categoryName ? "is-invalid" : ""}`}
                    placeholder="e.g. Medical Assistance / उदा. वैद्यकीय मदत"
                    value={categoryName}
                    onChange={(e) => {
                      setCategoryName(e.target.value);
                      if (errors.categoryName) setErrors((prev) => ({ ...prev, categoryName: "" }));
                    }}
                  />
                  {errors.categoryName ? (
                    <small className="text-danger d-block mt-1">{errors.categoryName}</small>
                  ) : (
                    <small className="text-muted d-block mt-1">
                      This category is used for help request letter generation.
                    </small>
                  )}
                </div>
              </div>

              <div className="mt-4 text-end">
                <button type="submit" className="btn btn-primary px-5" disabled={loading} style={{ fontSize: "0.85rem" }}>
                  {loading ? "Saving..." : "Add Category / श्रेणी जोडा"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default AddHelpCategory;
